module.exports = __webpack_public_path__ + "1d6600c436721252b8048b7bc6bfb806.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./modules/components/Dragon/dragon.jpg
 ** module id = 302
 ** module chunks = 1
 **/